module.exports = __webpack_public_path__ + "static/img/1Act.1da4b1f9.png";